<template>
  <div class="">
    <NuxtLink :to="localePath('/')">
      <!-- Regular logo (shown when not minimized) -->
      <div v-if="!isMinimized">
        <nuxt-img
          class="app-sidebar__brand__img app-sidebar__brand__img--original"
          :style="{ height: height }"
          loading="lazy"
          src="/images/Transkribus.svg"
          alt="Transkribus"
        />
        <nuxt-img
          class="app-sidebar__brand__img app-sidebar__brand__img--models"
          :style="{ height: height }"
          loading="lazy"
          src="/images/Transkribus-models.svg"
          alt="Transkribus"
        />
        <nuxt-img
          class="app-sidebar__brand__img app-sidebar__brand__img--sites"
          :style="{ height: height }"
          loading="lazy"
          src="/images/Transkribus-sites.svg"
          alt="Transkribus"
        />
      </div>
      <!-- Favicon (shown when minimized) -->
      <div
        v-else
        class="flex justify-center items-center place-self-center w-10 h-11"
      >
        <nuxt-img
          class="app-sidebar__brand__img app-sidebar__brand__img--original"
          loading="lazy"
          src="/images/icon_main.svg"
          alt="Transkribus"
        />
        <nuxt-img
          class="app-sidebar__brand__img app-sidebar__brand__img--models"
          loading="lazy"
          src="/images/icon_models.svg"
          alt="Transkribus"
        />
        <nuxt-img
          class="app-sidebar__brand__img app-sidebar__brand__img--sites"
          loading="lazy"
          src="/images/icon_sites.svg"
          alt="Transkribus"
        />
      </div>
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
const localePath = useLocalePath()

const props = defineProps<{
  isMinimized?: boolean
  height?: string
}>()
</script>

<style></style>
